import mixpanel from "mixpanel-browser";

export function getParamsFromUrl() {
    let paramString = window.location?.search || "";
    let searchParams = new URLSearchParams(paramString);
    let data = {};
  
    for (let p of searchParams) {
      let key = p[0];
      let value = p[1];
      data = {
          ...data,
          [key] : value
      }
    }
  
    return data;
}

export function isDevelopmentSite(){
  //return false;
  return window.location?.hostname?.toLowerCase() === "localhost";
}

export function trackUsage(event = '', payload = {}){
  if(event && !(isDevelopmentSite())){
      mixpanel.track(event,  payload);
  }
}